/**
 * Old org-scoped URLs that now live elsewhere (App.tsx maps each to a
 * `<LegacyRedirect>` route under `/org/:orgId`). The redirect keeps whatever
 * follows the old prefix — sub-path, query string and hash — so a bookmarked
 * `/accounting/impact?view=x#row` lands on `/impact?view=x#row`. It rewrites
 * the current pathname, so no org id is ever built by hand.
 *
 * Impact moved out of Accounting to `/impact` (org roles step 2): every role
 * reaches it, including a project manager, who never gets past the
 * `/accounting` scope guard or its tax-setup gate.
 */
export const LEGACY_IMPACT_REDIRECTS = [
  { path: 'accounting/impact/*', from: 'accounting/impact', to: 'impact' },
  { path: 'sustainability/*', from: 'sustainability', to: 'impact' },
] as const;
